<ng-container *ngIf="documentSerial; else plainText">
  <span
    [class]="getCssClasses()"
    [matTooltip]="tooltipText"
    matTooltipShowDelay="300"
    (click)="isNavigable && navigateToDocument()">
    {{ displayValue }}
    <mat-icon
      *ngIf="showIcon"
      class="icon-size-3 ml-1 inline-block"
      [class.opacity-50]="!isNavigable"
      svgIcon="heroicons_solid:arrow-top-right-on-square"
      style="color: inherit;">
    </mat-icon>
  </span>
</ng-container>

<ng-template #plainText>
  <span [class]="customClass">{{ displayValue }}</span>
</ng-template>